import React, {Component} from 'react';
import {Row, Col, Form, InputGroup, Button} from 'react-bootstrap';

import Pikaday from 'pikaday';
import PropTypes from 'prop-types';
import moment from 'moment'

export const formatDate = (v) => {
	if (!v) {
		return null
	}
	return new Date(v)
};


export class ReactPikadayComponent extends React.Component {
	static propTypes = {
		id: PropTypes.string,
		type: PropTypes.string,
		value: PropTypes.instanceOf(Date),
		onChange: PropTypes.func,
		disabled: PropTypes.bool,
		placeholder: PropTypes.string,
		readOnly: PropTypes.bool,
		name: PropTypes.string,
		style: PropTypes.object,
		tabIndex: PropTypes.number,
		valueLink: PropTypes.shape({
			value: PropTypes.instanceOf(Date),
			requestChange: PropTypes.func.isRequired
		})

		// see Pikaday options at https://github.com/dbushell/Pikaday#configuration
		// except `onSelect` and `field`
	};

	static defaultProps = {
		type: 'text'
	};

	componentDidMount() {
		const {value} = this._getValueLink(this.props);

		this._setupPikaday();
		this._setDateIfChanged(value);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const newDate = this._getValueLink(nextProps).value;
		const lastDate = this._getValueLink(this.props).value;

		this._setDateIfChanged(newDate, lastDate);
		this._setMinDateIfChanged(nextProps.minDate, this.props.minDate);
		this._setMaxDateIfChanged(nextProps.maxDate, this.props.maxDate);
	}

	componentDidUpdate(prevProps) {
		// update if container is set
		if (!prevProps.container && this.props.container) {
			const newDate = this._getValueLink(this.props).value;
			const lastDate = this._getValueLink(prevProps).value;

			this.pikaday.destroy();
			this._setupPikaday();
			this._setDateIfChanged(newDate, lastDate);
		}
	}

	componentWillUnmount() {
		this.pikaday.destroy();
	}

	render() {
		const {id, type, className, name, tabIndex, disabled, placeholder, readOnly, style} = this.props;

		return (
			<input
				id={id}
				type={type}
				ref="pikaday"
				name={name}
				className={className}
				style={style}
				placeholder={placeholder}
				disabled={disabled}
				readOnly={readOnly}
				tabIndex={tabIndex}
			/>
		);
	}

	_getValueLink(props) {
		return props.valueLink || {
			value: props.value,
			requestChange: props.onChange
		};
	}

	_setupPikaday() {
		const el = this.refs.pikaday;
		const {requestChange} = this._getValueLink(this.props);
		const {value, onChange, valueLink, ...pikadayOptions} = this.props; // eslint-disable-line no-unused-vars
		const options = Object.assign({}, pikadayOptions, {
			field: el,
			onSelect: requestChange
		});

		this.pikaday = new Pikaday(options);
	}

	_setDateIfChanged(newDate, prevDate) {
		this._setDate(newDate, prevDate, newTime => {
			if (isNaN(newTime)) {
				// workaround for pikaday not clearing value when date set to false
				const el = this.refs.pikaday;
				el.value = '';
			}
			this.pikaday.setDate(newDate, true); // not trigger onSelect
		});
	}

	_setMinDateIfChanged(newDate, prevDate) {
		this._setDate(newDate, prevDate, () => {
			this.pikaday.setMinDate(newDate);
		});
	}

	_setMaxDateIfChanged(newDate, prevDate) {
		this._setDate(newDate, prevDate, () => {
			this.pikaday.setMaxDate(newDate);
		});
	}

	_setDate(newDate, prevDate, setter) {
		const newTime = newDate ? newDate.getTime() : null;
		const prevTime = prevDate ? prevDate.getTime() : null;

		if (newTime !== prevTime) {
			setter(newTime);
		}
	}
}

class DateField extends Component {

	constructor(props) {
		super(props);

		this.handleOpenClick = this.handleOpenClick.bind(this)
	}

	handleOpenClick() {
		this.refs.pika.pikaday.show()
	}

	render() {

		const {
			feedbackIcon,
			input,
			label,
			sizes,
			clearable,
			meta: {error, warning, touched},
			onChangeHook,
			...props
		} = this.props;

		let message;
		const validationState = touched ? (error && "danger") || (warning && "warning") || null : null;

		if (touched && (error || warning)) {
			message = error || warning
		}

		return (
			<Form.Group as={Row} controlId={input.name}>
				<Form.Label column xs={sizes && sizes[0] ? sizes[0] : 4}>{label}</Form.Label>
				<Col xs={sizes && sizes[1] ? sizes[1] : 8}>
					<InputGroup>
						<ReactPikadayComponent
							ref="pika"
							i18n={{
								months: moment.localeData()._months,
								weekdays: moment.localeData()._weekdays,
								weekdaysShort: moment.localeData()._weekdaysShort
							}}
							format={moment.localeData().longDateFormat('L')}
							className={"form-control" + (touched && error ? " is-invalid" : "")}
							{...input}
							{...props}
							value={input.value || (input.value === "" ? null : input.value)}
							type={"text"}
							onChange={(value) => {
								if (onChangeHook) {
									onChangeHook(value);
								}
								return input.onChange(value);
							}}
						/>
						{clearable && input.value && <InputGroup.Append onClick={() => {
							input.onChange(null)
						}}>
							<Button variant={"warning"}>
								<span className="fa fa-remove"/>
							</Button>
						</InputGroup.Append>}
						{(!clearable || !input.value) && <InputGroup.Append onClick={this.handleOpenClick}>
							<Button variant={"info"}>
								<span className="fa fa-calendar"/>
							</Button>
						</InputGroup.Append>}
					</InputGroup>
					{message ? <div className={"text-" + validationState}>{message}</div> : null}
				</Col>
			</Form.Group>
		);
	}
}

export default DateField
